// --------------------------------------------------------
// ITEM LIST - ItemList
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React from 'react'
import { CompanyListContainer, CompanyListItemContainer} 
from '../../pages/company/CompanyList.styled'
import { GeneralContainer, Text } from '../../components/UI/generalLayout/Layout.styled';
import useResponsiveInfo from '../../hooks/useResponsiveInfo';
import ListHeader from './ListHeaders';

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// ITEM LIST INTERFACE
// --------------------------------------------------------

interface IItemList{
    list: any[];
    listHeader: any[];
    children: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const ItemList = ({list, listHeader, children}:IItemList) => {
  // --------------------------------------------------------
  // ITEM LIST PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { isMobile } = useResponsiveInfo()

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
        {!isMobile && <ListHeader fields={listHeader} />}
        <CompanyListContainer>
            {list.length > 0?  (
            <CompanyListItemContainer>
                {children}
            </CompanyListItemContainer>)
            :(
            <GeneralContainer>
                <Text>Nenhum resultado encontrado</Text>
            </GeneralContainer>
            )}
        </CompanyListContainer>
    </>
  )
  // --------------------------------------------------------
}

export default ItemList